export class StepAfterSetupReconnecting {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "after_setup_reconnecting";
  title = "Reconnecting to Wi-Fi";

  template = `
  <div class="onboarding-step" data-for="after_setup_reconnecting">

    <div class="onboarding-loading is-active">
      <div class="onboarding-loading__animation">
        <img src="${window.site.home}/../assets/images/setup/loader-spinning-blue-circle.svg" width="200" height="200" />
      </div>
      <div class="onboarding-loading__text">
        Reconnecting Wi-Fi...
      </div>
    </div>

    <div class="onboarding-save-sensor-message is-active">
      Please wait while your Wi-Fi reconnects
    </div>

  </div>
  `;

  async GetReadings() {

    if (this.onboarding.current_step === this.id) {

      try {

        const readings = await this.onboarding.Temp_Stick_Request('GET', '/get/readings');

        this.last_reading = readings;
        this.onboarding.last_reading = readings;

      } catch (e) {
        setTimeout(this.GetReadings.bind(this), 1000);
      }

    }

  }

  normalizeContacts(contactsResponse) {
    if (Array.isArray(contactsResponse)) {
      return contactsResponse;
    }

    if (contactsResponse && Array.isArray(contactsResponse.contacts)) {
      return contactsResponse.contacts;
    }

    return [];
  }

  hasDefaultContact(contacts) {
    return contacts.some(contact => {
      if (!contact) {
        return false;
      }

      return (
        contact.is_default === true ||
        contact.is_default === 1 ||
        contact.is_default === "1"
      );
    });
  }

  async goToNextStep() {

    if (this.hasRouted) {
      return;
    }

    this.hasRouted = true;

    const sensorId = this.onboarding.sensor.sid;

    const r = await window.apiRequest(
      'post',
      `/sensor/${encodeURIComponent(sensorId)}/after-onboarding`,
      {
        tempC: this.onboarding.last_reading.tempC ?? this.onboarding.last_reading.tempC,
        humidity: this.onboarding.last_reading.humidity ?? this.onboarding.last_reading.humidity,
      }
    );

    // The zip code answered while the phone was offline on the sensor's
    // network. The sensor is on the account now and the phone is back online,
    // so this is the first moment it can be saved.
    await this.onboarding.submitSensorZipCode();

    // Registering the sensor is what links a selective account to its
    // enterprise (the API does it on /sensor/create during the Wi-Fi test), so
    // the session payload loaded at page start predates the link. Refresh it so
    // the steps after this one see the account as it is now.
    await this.refreshCurrentUser();

    if (this.onboarding.isEnterpriseSensor()) {
      // An enterprise-related sensor gets the alerts review and the contact
      // confirmation before finishing: step_setup_alerts -> step_setup_contacts
      // -> after_setup_selective_questions (selective program only) ->
      // after_setup_name_sensor.
      this.onboarding.goToStep('step_setup_alerts');
      return;
    }

    this.onboarding.goToStep('after_setup_name_sensor');

  }

  async refreshCurrentUser() {

    try {

      const r = await window.apiRequest("post", "/authenticate");

      if (r && r.type === "success" && r.data && r.data.user) {
        window.currentUser = r.data.user;
      }

    } catch (e) {
      // Not fatal: the sensor-ID rule still routes the selective steps.
    }

  }

  onBack = () => {}

  onActivate = async () => {

    clearInterval(this.onboarding.status_interval);
    clearInterval(this.onboarding.get_wifi_networks_interval);
    clearInterval(this.testConnectionInterval);

    this.hasRouted = false;
    this.testConnectionCount = 0;

    this.onboarding.completed_setup = true;

    this.$saveSensorMessage.removeClass('is-error');
    this.$saveSensorMessage.addClass('is-active');
    this.$saveSensorMessage.html('Please wait while your Wi-Fi reconnects');

    await this.GetReadings();

    try {
      this.onboarding.Temp_Stick_Request('GET', '/restart', {}, true);
    } catch (e) {
      console.log("Error /restart", e.message);
    }

    // Release the sensor link (Wi-Fi network or Bluetooth connection) once the
    // fire-and-forget /restart has had time to get out.
    setTimeout(() => {
      this.onboarding.Temp_Stick_Disconnect();
    }, 5000);

    this.testConnectionInterval = setInterval(() => {

      $.ajax({
        url: window.site.home + "/../connection-test",
        type: 'GET',
        timeout: 2000,
        success: async () => {

          clearInterval(this.testConnectionInterval);

          this.onboarding.Set_Connected(false);

          this.$saveSensorMessage.removeClass('is-error');
          this.$saveSensorMessage.addClass('is-active');
          this.$saveSensorMessage.html('Connected. Finishing setup...');

          await this.goToNextStep();

        },
        error: () => {

          this.testConnectionCount++;

          if (this.testConnectionCount > 30) {
            this.$saveSensorMessage.addClass('is-error');
            this.$saveSensorMessage.html('You might need to manually connect to your Wi-Fi');

            if (this.testConnectionCount > 120) {
              this.$saveSensorMessage.html("Your Temp Stick was successfully set up but your device is offline.");
              clearInterval(this.testConnectionInterval);
            }
          }

        }
      });

    }, 2500);

  }

  bindActions = () => {
    this.$saveSensorMessage = $(this.onboarding.container).find('.onboarding-step[data-for="after_setup_reconnecting"] .onboarding-save-sensor-message');
  }

}